/**
 * UserDeviceTablePage - User device management using TablePage component
 * Clean implementation using TablePage with minimal overrides
 */

import TablePage from '@core/pages/TablePage.js';
import { UserDevice, UserDeviceList } from '@core/models/User.js';
import DeviceView from './DeviceView.js';

UserDevice.VIEW_CLASS = DeviceView;

class UserDeviceTablePage extends TablePage {
    constructor(options = {}) {
        super({
            ...options,
            name: 'admin_user_devices',
            pageName: 'User Devices',
            router: "admin/user/devices",
            Collection: UserDeviceList,

            dayRangeFilter: { field: 'last_seen', value: '30d' },
            searchPlaceholder: 'Search user, IP, or device ID',

            viewDialogOptions: {
                header: false,
                noBodyPadding: true,
                buttons: []
            },

            // Column definitions
            columns: [
                { key: 'id', label: 'ID', width: '70px', sortable: true, class: 'text-muted' },
                { key: 'duid', label: 'Device ID', sortable: true, formatter: 'truncate_middle(16)', visibility: 'xxl' },
                { key: 'user.display_name', label: 'User', sortable: true, formatter: "default('—')" },
                { key: 'device_info.user_agent.family', label: 'Browser', formatter: "default('—')", visibility: 'lg' },
                { key: 'device_info.os.family', label: 'OS', formatter: "default('—')", visibility: 'xl' },
                { key: 'last_ip', label: 'Last IP', sortable: true },
                { key: 'first_seen', label: 'First Seen', formatter: "epoch|datetime", visibility: 'xl' },
                { key: 'last_seen', label: 'Last Seen', formatter: "epoch|datetime" }
            ],

            // Table features
            selectable: true,
            searchable: true,
            sortable: true,
            filterable: true,
            paginated: true,

            // Toolbar
            showRefresh: true,
            showAdd: false,
            showExport: true,

            // Empty state
            emptyMessage: 'No user devices found.',

            // Table display options
            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: false
            }
        });
    }
}

export default UserDeviceTablePage;
